import { Component, EventEmitter, Input, Output } from '@angular/core';
import moment from 'moment/moment';
import { BsModalService, ModalOptions } from 'ngx-bootstrap/modal';

import {
  MessageAttachmentHelpProps,
  MessageHelp,
} from '../../../../data/help-me/domain/message-help';
import { ConfirmationModalComponent } from '../../../components/confirmation-modal/confirmation-modal.component';
import { SCREENSHOT_MIME_TYPES } from '../../help-me.component';
import { HelpMeFacade } from '../../help-me.facade';
import {
  HelpMeCategories,
  HelpMeCategoriesTools,
} from '../../help-me-categories';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'msd-message-help',
  templateUrl: './message-help.component.html',
  styleUrls: ['./message-help.component.scss'],
})
export class MessageHelpComponent {
  @Input() message: MessageHelp;
  @Output() refresh = new EventEmitter();
  hasReplier = false;
  content: string | undefined;
  acceptedFiles = SCREENSHOT_MIME_TYPES.join(',');
  attachments: MessageAttachmentHelpProps[] = [];
  isSubmitted = false;

  constructor(
    private facade: HelpMeFacade,
    private modalService: BsModalService,
  ) {
    // Nada
  }

  getLabelCategory(category: HelpMeCategories) {
    return HelpMeCategoriesTools.getLabelCategory(category);
  }

  getLabelDate(createdAt: Date) {
    return 'le ' + moment(createdAt).format('DD.MM.YY à HH:mm');
  }

  getContent(content: string) {
    return content.replaceAll('\n', '<br>');
  }

  addAttachment(event: Event) {
    if (
      !(event.target instanceof HTMLInputElement) ||
      !event.target.files ||
      event.target.files.length == 0
    ) {
      return;
    }

    const file: File = event.target.files[0];
    this.attachments.push({
      file,
      status: 'init',
      name: file.name,
      size: file.size,
      mimeType: file.type,
    } as MessageAttachmentHelpProps);
    event.target.value = '';
  }

  removeAttachment(attachment: MessageAttachmentHelpProps) {
    for (let i = 0; i < this.attachments.length; i++) {
      this.attachments.splice(this.attachments.indexOf(attachment), 1);
    }
  }

  closeReplier() {
    this.hasReplier = false;
    this.content = undefined;
    this.attachments = [];
  }

  enablePostReplier() {
    return this.content && this.content.length > 0;
  }

  async postReplier() {
    if (!this.isSubmitted) {
      this.isSubmitted = true;
      this.message.answered = false;
      await this.facade.postReply(this.message, {
        supportReply: false,
        createdAt: new Date(),
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        content: this.content!,
        attachments: this.attachments,
      });
      this.closeReplier();
      this.isSubmitted = false;
    }
  }

  canReply() {
    return (
      this.message.thread &&
      this.message.thread.length > 0 &&
      this.message.thread[this.message.thread.length - 1].supportReply
    );
  }

  previewAttachment(attachment: MessageAttachmentHelpProps) {
    window.open(attachment.url, '_blank');
  }

  closeMessageHelp() {
    const initialState: ModalOptions = {
      class: 'modal-md modal-dialog-centered',
      initialState: {
        title: `Êtes-vous sûr ?`,
        subtitle:
          "Souhaitez-vous réellement fermer cette demande, elle ne sera pas traitée par l'équipe MonSuiviDiet et ne pourra plus être consultée ?",
      },
    };
    const modal = this.modalService.show(
      ConfirmationModalComponent,
      initialState,
    );
    if (modal.content instanceof ConfirmationModalComponent) {
      modal.content.validate.subscribe(async () => {
        await this.facade.closeMessageHelp(this.message);
        this.refresh.emit();
      });
    }
  }
}
